<footer class="portal-footer">
  <span class="footer-agency">Oregon Health Authority</span>
  <nav aria-label="Footer">
    <a routerLink="/accessibility-notice">Accessibility Statement</a>
    <a href="https://www.oregon.gov/oha/ph/providerpartnerresources/healthcareprovidersfacilities/healthcarehealthcareregulationqualityimprovement/pages/index.aspx"
       target="_blank" rel="noreferrer noopener">Health Facility Licensing and Certification <span class="visually-hidden">(opens in a new tab)</span></a>
  </nav>
  <span class="footer-version">{{environment.build}} · Version {{environment.version}}</span>
</footer>
